import type { GetDesignerPreferencesResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { useGetCurrentProjectId } from "@/hooks/useGetCurrentProjectId";
import authenticatedApi from "@/lib/api/client";

export function usePreferredDesigners(): UseQueryResult<GetDesignerPreferencesResponse> {
  const projectId = useGetCurrentProjectId();

  return useQuery({
    enabled: !!projectId,
    queryFn: async () =>
      await authenticatedApi
        .url(`/projects/${projectId}/designer-preferences`)
        .query({ profilePic: true })
        .get()
        .json<GetDesignerPreferencesResponse>(),
    queryKey: ["designer-preferences", projectId],
  });
}
